<table class="nested-table">
  <thead>
    <tr>
      <th>{{ "GRID.PLAN_NAME" | translate }}</th>
      <th>{{ "GRID.NO_OF_SKUS" | translate }}</th>
      <th>{{ "GRID.DOORS" | translate }}</th>
      <th>{{ "GRID.SHELVES" | translate }}</th>
      <th>
        {{ "GRID.WIDTH" | translate }} x {{ "GRID.HEIGHT" | translate }} x
        {{ "GRID.DEPTH" | translate }}
      </th>
      <th>{{ "GRID.CREATED_BY" | translate }}</th>
      <th>{{ "GRID.CREATED_AT" | translate }}</th>
      <th>{{ "GRID.STATUS" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="getPlans(data) as plans">
      <ng-container *ngIf="plans.length > 0; else noPlanData">
        <tr *ngFor="let plan of plans">
          <td>{{ plan?.name }}</td>
          <td>{{ plan?.sku_count ?? "-" }}</td>
          <td>{{ plan?.grid?.doors ?? "-" }}</td>
          <td>{{ plan?.grid?.shelves ?? "-" }}</td>
          <td>
            <ng-container
              *ngIf="
                plan?.grid?.width && plan?.grid?.height && plan?.grid?.depth;
                else noGridData
              "
            >
              {{ plan?.grid?.width }} x {{ plan?.grid?.height }} x
              {{ plan?.grid?.depth }}
            </ng-container>
            <ng-template #noGridData>-</ng-template>
          </td>
          <td>
            {{ plan?.owner_by?.first_name }}
            {{ plan?.owner_by?.last_name }}
          </td>
          <td>{{ formatHumanReadableDate(plan?.created_at) }}</td>
          <td class="{{ plan?.status }}">
            {{ plan?.status | titleCase }}
          </td>
          <td>
            <ng-container *ngFor="let action of actionIconList">
              <app-svg-icon
                class="cursor-pointer"
                [icon]="action.icon"
                [color]="action.color"
                padding="8px"
                [matTooltip]="action.label"
                (click)="
                  actionCallback(action, plan, data); $event.stopPropagation()
                "
              ></app-svg-icon>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </ng-container>

    <ng-template #noPlanData>
      <tr>
        <td class="rounded-lg text-center px-2 py-3" colspan="9">
          {{ "PHO.NO_RECORDS_FOUND" | translate }}
        </td>
      </tr>
    </ng-template>
  </tbody>
</table>
